import { useNavigate } from 'react-router';
import { PathnameEnum } from '@constant';

//메인페이지 로직에 관여
export const useMain = () => {
  const navigate = useNavigate();

  const handleStandardClick = () => {
    navigate(PathnameEnum.STANDARD_OUTPUT_PAGE);
  };

  const handleAdultsOnlyClick = () => {
    navigate(PathnameEnum.ADULTS_ONLY_OUTPUT_PAGE);
  };

  const handleActionGenreClick = () => {
    navigate(PathnameEnum.ACTION_GENRE_OUTPUT_PAGE);
  };

  const handleBodyPartClick = () => {
    navigate(PathnameEnum.BODY_PART_OUTPUT_PAGE);
  };

  const handleFacialExpressionClick = () => {
    navigate(PathnameEnum.FACIAL_EXPRESSION_OUTPUT_PAGE);
  };

  const handleEtcClick = () => {
    navigate(PathnameEnum.ETC_OUTPUT_PAGE);
  };

  const handleThreeDClick = () => {
    navigate(PathnameEnum.THREE_D_OUTPUT_PAGE);
  };

  return {
    handleStandardClick,
    handleAdultsOnlyClick,
    handleActionGenreClick,
    handleBodyPartClick,
    handleFacialExpressionClick,
    handleEtcClick,
    handleThreeDClick
  };
};
